<template>
  <span
    >{{ texts.fromLabel }} {{ currencySymbol }} {{ monthlyFee | formatAmount }}
    {{ texts.pmLabel }}</span
  >
</template>

<script>
export default {
  name: "InstalmentAmount",
  props: {
    texts: { type: Object },
    currencySymbol: { type: String },
    monthlyFee: { type: String }
  }
};
</script>
